import { useState } from 'react';
import { Link } from 'react-router-dom';
import EmailText from '../EmailText';
import { cleanEmailText, needsReadMore } from '../../utils/emailText';
import { initialsOf, relativeDate, formatDate } from './CustomerParts';

// One entry per note or closed ticket, newest first. Long notes (including
// pasted emails) show five lines with Read more, the same as the ticket page.
function Entry({ item }) {
  const [open, setOpen] = useState(false);
  const isTicket = item.type === 'ticket';
  const body = cleanEmailText(item.text);
  const canExpand = !isTicket && needsReadMore(body);

  const inner = (
    <>
      <span className={`cx-tl-dot ${isTicket ? 'is-ticket' : ''}`} aria-hidden="true">
        {isTicket ? <i className="fas fa-ticket"></i> : initialsOf(item.author)}
      </span>
      <div className="cx-tl-card">
        <div className="cx-tl-head">
          <span className="cx-tl-author">{item.author}</span>
          {isTicket && <span className="cx-chip cx-chip-muted">Ticket</span>}
          {item.internal_external === 'internal' && !isTicket && <span className="cx-chip cx-chip-warn">Internal</span>}
          <time className="cx-tl-date" dateTime={item.dateObj.toISOString()} title={formatDate(item.dateObj)}>{relativeDate(item.dateObj)}</time>
        </div>
        <div className={`cx-tl-text ${canExpand && !open ? 'is-clamped' : ''}`}>
          <EmailText text={open ? body.full : body.reply} />
        </div>
        {canExpand && (
          <button type="button" className="cx-link-btn" onClick={() => setOpen((v) => !v)} aria-expanded={open}>
            {open ? 'Show less' : 'Read more'}
          </button>
        )}
      </div>
    </>
  );

  return isTicket
    ? <li><Link to={`/tickets/${item.ticket_id}`} className="cx-tl-item is-link">{inner}</Link></li>
    : <li className={`cx-tl-item ${item.internal_external === 'internal' ? 'is-internal' : ''}`}>{inner}</li>;
}

export default function CustomerTimeline({ items }) {
  return <ol className="cx-timeline">{items.map((item) => <Entry key={`${item.type || 'note'}-${item.id}`} item={item} />)}</ol>;
}
